import { createFileRoute } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"

import { CniDevicesGlobe } from "@/features/cni-overview/components/CniDevicesGlobe"
import { CniOverviewKpis } from "@/features/cni-overview/components/CniOverviewKpis"
import { CniRegionalAggregation } from "@/features/cni-overview/components/CniRegionalAggregation"

/**
 * CNI Genel Bakış — KPI strip + 3D Globe (cihaz dağılımı) + alt bölüm
 * regional aggregation. Önceki standalone /cni/map route'u bu sayfaya
 * absorbe edildi.
 */
export const Route = createFileRoute("/_authed/cni/dashboard")({
  component: CniDashboardPage,
})

function CniDashboardPage() {
  const { t } = useTranslation("cni-overview")
  return (
    <div className="h-full flex flex-col min-h-0">
      <div className="border-b border-ok-border px-6 py-4 shrink-0">
        <h1 className="text-lg font-semibold tracking-tight">{t("title")}</h1>
        <p className="text-xs text-ok-foreground-muted">{t("subtitle")}</p>
      </div>
      <div className="flex-1 flex flex-col min-h-0 overflow-auto">
        <div className="shrink-0">
          <CniOverviewKpis />
        </div>
        <div className="shrink-0 h-[640px] xl:h-[760px] p-4 pt-0">
          <CniDevicesGlobe />
        </div>
        <div className="shrink-0">
          <CniRegionalAggregation />
        </div>
      </div>
    </div>
  )
}
